import React from "react";
import { RiArrowLeftSLine, RiArrowRightSLine } from "react-icons/ri";
import { useMediaQuery } from "react-responsive";

import {
  Container,
  Overlay,
  LinksContainer,
  Body,
  SidebarCollapseButton,
  FooterContainer,
} from "./styles";

import { useAuth } from "../../hooks/AuthContext";
import { useOnboard } from "../../hooks/OnboardContext";
import { LicenseeMenuList } from "./MenuList/LicenseeMenuList";
import { AdminMenuList } from "./MenuList/AdminMenuList";
import { CreatorMenuList } from "./MenuList/CreatorMenuList";
import { FixiterMenuList } from "./MenuList/FixiterMenuList";
import { roles } from "../../utils/constants";
import { LanguageSelector } from "../LanguageSelector";

interface SideBarProps {
  extendedMode: boolean;
  setExtendedMode: (val: boolean) => void;
  isMenuOpen: boolean;
  toggleMenu: () => void;
}

const SideBar = ({ extendedMode, setExtendedMode, isMenuOpen, toggleMenu }: SideBarProps) => {
  const { user, isFixiter: authIsFixiter, isLicenseeWithPrinter: authIsLicenseeWithPrinter } = useAuth();
  const { isFixiter: onboardIsFixiter, isLicenseeWithPrinter: onboardIsLicenseeWithPrinter } = useOnboard();
  const isLicenseeWithPrinter = onboardIsLicenseeWithPrinter || authIsLicenseeWithPrinter;
  const isFixiter = isLicenseeWithPrinter ? false : (onboardIsFixiter || authIsFixiter);
  
  // Responsive hook to detect mobile
  const isMobile = useMediaQuery({ maxWidth: 768 });

  const toggleExtendedMode = () => {
    setExtendedMode(!extendedMode);
  };

  // On mobile, the menu is ALWAYS extended visually (passing true to components), 
  // even if the global desktop state is collapsed.
  const isExpandedVisually = isMobile ? true : extendedMode;

  return (
    <>
      <Overlay isMenuOpen={isMenuOpen} onClick={toggleMenu} />
      
      <Container extendedMode={extendedMode} isMenuOpen={isMenuOpen}>
        {!isMobile && (
          <SidebarCollapseButton extendedMode={extendedMode} onClick={toggleExtendedMode}>
            {extendedMode ? <RiArrowLeftSLine size={24} /> : <RiArrowRightSLine size={24} />}
          </SidebarCollapseButton>
        )}
        <Body>
          <LinksContainer onClick={() => {
            // Optional: Auto close mobile menu when a link is clicked, UNLESS it's a submenu toggle
            // We'll let the user decide if they want this behavior.
          }}>
            {(user.role === roles.licensee || user.role === roles.fixiter) && (
              isFixiter ? (
                <FixiterMenuList extendedMode={isExpandedVisually} setExtendedMode={setExtendedMode} />
              ) : (
                <LicenseeMenuList extendedMode={isExpandedVisually} setExtendedMode={setExtendedMode} />
              )
            )}
            {user.role === roles.creator && (
              <CreatorMenuList extendedMode={isExpandedVisually} setExtendedMode={setExtendedMode} />
            )}
            {user.role === roles.admin && (
              <AdminMenuList 
                extendedMode={isExpandedVisually} 
                setExtendedMode={setExtendedMode}
              />
            )}
          </LinksContainer>

          <FooterContainer>
            <LanguageSelector position="top" variant="solid" />
          </FooterContainer>
        </Body>
      </Container>
    </>
  );
};

export default SideBar;
